import { css, keyframes } from '@emotion/core'
import { mqMin, mq, TxtLimit, CommonTxtBoxStyle } from '@styles/base.style'
import styled, { Theme, ThemeProps } from '@themes/theme'

const ItemAni = keyframes`
  0%, 100% {
    left: 50%;
    transform: translate3d(-50%, -2px, 0);
  }
  50% {
    left: 50%;
    transform: translate3d(-50%, -4px, 0);
  }
`
const ItemPickAni = keyframes`
  0%, 100% {
    transform: translate3d(-50%, 1px, 0);
  }
  50% {
    transform: translate3d(-50%, -1px, 0);
  }
`


export const RowStyle = css`
  width: 100%;
  padding: 12px 14px;
`
export const TopBtnStyle = (theme: Theme) => css`
  display: inline-block;
  width: 56px;
  height: 24px;
  margin-left: 10px;
  padding: 0;
  line-height: 2.4rem;
  text-align: center;
  font-size: ${theme.font.small};
  /* color: ${theme.color.themeTxt}; */
  &.delete-all {
    background: ${theme.color.btn};
  }
  &.disabled {
    opacity: 0.5;
    background: ${theme.color.btn};
  }
  ${mq[0]}{
    margin-left: 4px;
  }
`

export const ListWrap = styled.article`
  width: 100%;
  background: ${props => props.theme.color.contentsBg};
  .ant-list-bordered {
    overflow: hidden;
  }
  .ant-list-bordered .ant-list-header {
    padding: 0;
    border: none;
  }
  .ant-list-bordered .ant-list-item {
    padding: 0;
  }
  /* 가로 화면 / 태블릿일때도 한줄로 보이도록 설정 */
  .ant-list-item {
    position: relative;
    ${mqMin[2]} {
      display: block;
      overflow: hidden;
    }
  }
  .ant-list-bordered {
    border-radius: 0;
    border: none;
  }

  &.send {
    button.pick {
      display: none;
    }
    .item-style {
      transform: translate(-50%, -50%);
    }
    .item-text {
      display: none;
    }
  }
`
export const ListHeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 62px;
  padding: 0 14px;
  //background: ${props => props.theme.color.themeTxt};
  //border-bottom: 1px solid ${props => props.theme.color.modalBg};

  position: absolute;
  bottom: 3px;
  right: 0;
  justify-content: flex-end;
  height: 39px;
  padding: 0 9px;
  .ant-select-selection-selected-value {
    font-size: ${props => props.theme.font.small};
  }
  .list-tit {
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.medium};
    color: ${props => props.theme.color.modalgray};
  }
`
export const SelectStyle = css`
  top: 5px;
  float: right;
  width: 110px;
  line-height: 3rem;
`
export const OptionTxt = styled.span`
  font-size: ${props => props.theme.font.small};
`

export const messageSenderStyle = (props: ThemeProps) => css`
  .sender-profile {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 48px;
    margin-right: 10px;
    overflow: hidden;
    border-radius: 50%;
    background: ${props.theme.color.modalBg};
    &--img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: auto;
      &.custom-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.system {
        width: inherit;
      }
    }
  }
  .message-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .sender-info {
      width: auto;
      position: relative;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .sender {
        width: 100%;
        color: ${props.theme.color.modalTxt};
        font-size: ${props.theme.font.large};
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // 메시지함_보낸 메시지  
        .status {
          margin-left: 5px;
          height: 18px;
          width: auto;
          border-radius: 9px;
          padding: 0 7px;
          background: ${props.theme.color.modalBg};
          .txt {
            line-height: 18px;
            color: ${props.theme.color.modalgray};
            font-size: ${props.theme.font.small};
            font-weight: ${props.theme.fontW.medium};
            &.not-read {
              display: block
            }
            &.read {
              display: none;
            }
          }
          &.read {
            .not-read {
              display: none;
            }
            .read {
              display: block;
            }
          }
        }
      }
      .date, .term {
        width: 100%;
        color: ${props.theme.color.modalgray};
        font-size: ${props.theme.font.small};
        font-weight: ${props.theme.fontW.medium};
        text-align: left;
        .term {
          &::before {
            display: inline;
            content: 'ㅣ';
            width: 15px;
            height: 9px;
            font-size: ${props.theme.font.small};
            font-weight: ${props.theme.fontW.medium};
            margin: 0 2px;
          }
        }
      }
    }
    .message-item {
      // do something
    }

  } 

`

// message list
export const AccordionWrapper = styled.div`
  margin-bottom: 10px;
  &:first-of-type {
    margin-top: 16px;
  }
  .ant-collapse {
    background: #F7F7F7 !important;
    margin: 0 14px;
    border-radius: 12px;
    box-shadow: 0 2px 4px #0000000F;
    overflow: hidden;
    .ant-collapse-item {
      .ant-collapse-header {
        display: flex;
        flex-wrap: wrap;
        padding: 13px 17px 16px 20px;
        background: #F7F7F7;
        .ant-collapse-header-top {
          ${messageSenderStyle};
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .message-summary {
          flex: 1;
          display: block;
          width: 100%;
          height: 20px;
          border: 1px solid transparent;
          margin-top: 9px;
          position: relative;
          &-txt {
            width: 100%;
            height: auto;
            position: absolute;
            display: block;
            overflow: visible;
            text-align: left;
            ${TxtLimit};
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.large};
            font-weight: ${props => props.theme.fontW.medium};
            * {
              line-height: 2rem;
              text-align: left;
              ${TxtLimit};
              color: ${props => props.theme.color.modalTxt} !important;
              font-size: ${props => props.theme.font.large};
              font-weight: ${props => props.theme.fontW.medium};
            }
          }
          &::before {
            content: '';
            display: none;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
            width: 100%;
            height: 1px;
            background: ${props => props.theme.color.modalBg};
          }
          &.is-preview-empty {
            height: 0;
            margin: 0;
            &::before {
              transform: translate3d(-50%, 9px, 0);
            }
          }
        }
      }
      &.ant-collapse-item-active {
        .message-summary {
          &-txt {
            display: none;
            content: '';
            width: 100%;
            height: auto;
            position: absolute;
          }
          &::before {
            display: block;
          }
        }
      }
      .ant-collapse-content {
        overflow: visible;
        position: relative;
        z-index: 2;
        background: #F7F7F7;
        .ant-collapse-content-box {
          transform: translateY(-15px);
          padding: 0 20px 5px 20px;
          background: #F7F7F7;
          & > * {
            user-select: text; /* auto로 할 경우 PC에서 선택이 안됨 */
          }
        }
      }
      // 픽 구매 버튼
      .message-pick-btn {
        &.complete, &.end {
          display: none;
          color: ${props => props.theme.color.modalTxt};
        }
      }
      // 베팅 공유 저장 버튼
      .message-bet-btn  {
        &.save-complete {
          display: none;
          color: ${props => props.theme.color.modalTxt};
        }
      }
      &:not(.read) {
        .new-message-badge {
          position: absolute;
          top: 20px;
          left: 57px;
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: ${props => props.theme.color.red};
        }
      }
      /* 읽은 메시지 */
      //&.read {
      //
      //}
      /* 픽 마감 */
      &.end {
        .header-item-btn {
          opacity: .5;
        }
        .end-pick {
          display: block;
        }
        .item-img {
          svg, img {
            transform: translate(-50%, 0);
            animation: none;
          }
        }
        // 픽 구매 버튼
        .message-pick-btn {
          &.buy, &.complete {
            display: none;
          }
          // 픽 구매 마감
          &.end {
            display: block;
          }
        }
        // 구매완료한 픽
        .pick-content {
          opacity: 0.5;
        }
      }
      /* 아이템 수령 혹은 픽구매 완료 메시지 */
      &.received {
        .end-pick {
          display: none;
        }
        .attached-item {
          .item-img {
            display: none;
          }
          & > svg {
            margin-bottom: -2px;
          }
        }
        .download-icon {
          display: none;
        }
        // 첨부 아이템 수령 전 박스 아이콘
        .item-box-icon {
          display: block;
        }
        // 픽 구매 버튼
        .message-pick-btn {
          &.buy, &.end {
            display: none;
          }
          &.complete {
            display: block;
          }
        }
        // 베팅 공유 저장 버튼
        .message-bet-btn  {
          &.save {
            display: none;
          }
          &.save-complete {
            display: block;
          }
        }
      }
      //&.end.received {
      //  // 픽 구매 버튼
      //  .pick-content {
      //    .message-pick-btn {
      //      &.end {
      //        display: block;
      //      }
      //    }
      //  }
      //
      //}
      &.sent-message-list {
        .new-message-badge {
          display: none;
        }
      }
    }
  }
  .sender-profile {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    margin-right: 21px;
    overflow: hidden;
    border-radius: 50%;
    background: ${props => props.theme.color.modalBg};
    &--img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: auto;
      &.custom-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.system {
        width: inherit;
      }
    }
  }
  .message-info {
    flex: 1;
    width: calc(100% - 81px);
    height: 58px;
    .sender-info {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 6px;
      .sender {
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
      }
      .date {
        color: ${props => props.theme.color.modalgray};
        font-size: ${props => props.theme.font.small};
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
    .message-contents {
      display:flex;
      justify-content: space-between;
      align-items: center;
      .message-summary {
        flex: 1;
        display: inline-block;
        ${TxtLimit};
        width: 100%;
        height: 36px;
        padding-right: 10px;
        line-height: 3.6rem;
        text-align: left;
        color: ${props => props.theme.color.modalgray};
        font-weight: ${props => props.theme.fontW.medium};
        * {
          font-weight: ${props => props.theme.fontW.medium} !important;
          font-size: ${props => props.theme.font.medium} !important;
          color: ${props => props.theme.color.modalgray};
        }
      }
      .message-item-btn {
        width: 36px;
        height: 36px;
        margin-left: 10px;
        background: red;
      }
    }
  }
  .status {
    .txt {
      color: ${props => props.theme.color.modalgray};
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      &.not-read {
        display: block
      }
      &.read {
        display: none;
      }
    }
    &.read {
      .not-read {
        display: none;
      }
      .read {
        display: block;
      }
    }
  }

  /* 픽 마감 */
  // .end {
  // /* 읽은 메시지 */
  // .read {
  //   .am-accordion-header {
  //     position: relative;
  //     .header-txt {
  //       color: ${props => props.theme.color.disableTxt};
  //     }
  //   }
  // }
  // /* 아이템 수령 혹은 픽구매 완료 메시지 */
  // .received {
  //   button {
  //     z-index: 0;
  //     .item-wrap::before {
  //       display: none;
  //     }
  //     .item-style,
  //     &::before {
  //       opacity: 0.7;
  //     }
  //     span.item-text {
  //       display: none;
  //     }
  //     img.received-icon,
  //     span.item-text.complete {
  //       display: block;
  //     }
  //     &.pick, &.end {
  //       display: none;
  //     }
  //     &.complete {
  //       display: block;
  //     }
  //   }
  //   .pick-content {
  //     opacity: 0.5;
  //   }
  // }
`
// 아이템 수령 버튼
export const ItemWrapBtnStyle = (theme:Theme) => css`
  width: 48px;
  height: 48px;
  background: ${theme.color.modalBg};
  border-radius: 8px;
  .attached-item {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    .item-img {
      svg, img {
        position: absolute;
        top: 11px;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        width: 34px;
        height: auto;
        animation: ${ItemAni} 1.5s infinite;
        &.shared-bet-ico {
          top: 17px;
          height: 20px;
        }
      }
      &.pick-item {
        svg, img {
          animation: ${ItemPickAni} 1.5s infinite;
        }
      }
    }
    .end-pick {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${theme.color.modalBg};
      border-radius: 50%;
      opacity: .5;
    }
    & > svg {
      position: relative;
      height: auto;
      margin-bottom: -11px;
    }
    &.sent-message {
      .item-img {
        svg, img {
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          width: auto;
          min-height: 12px;
          max-height: 20px;
          animation: none;
        }
      }
    }
    // 첨부 아이템 수령 전 박스 아이콘
    .item-box-icon {
      display: none;
    }
    // 첨부 아이템 수령 후 박스 아이콘
    &.received {
      .item-box-icon {
        display: block;
      }
    }
  }
  // 첨부 아이템 수령 가능 아이콘
  .download-icon {
    position: absolute;
    bottom: -1px;
    right: -2px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${theme.color.accordion2};
    & > svg {
      width: 100%;
      margin: 0;
    }
  }

`
export const MessageBody = styled.div`
  ${CommonTxtBoxStyle};
  height: auto;
  margin-bottom: 24px;
  color: ${props => props.theme.color.modalTxt};
  font-size: ${props => props.theme.font.large};
  font-weight: ${props => props.theme.fontW.medium};
  text-align: left;
  > p {
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
    white-space: normal;
  }
  * {
    ${CommonTxtBoxStyle};
    white-space: normal;
    font-weight: ${props => props.theme.fontW.bold};
    font-size: ${props => props.theme.font.large};
    color: revert-layer;
    &:not(strong) {
      font-weight: ${props => props.theme.fontW.medium} !important;
    }
  }
`
export const MessageFooter = (theme: Theme) => css`
  z-index: 1;
  position: relative;
  height: auto;
  text-align: left;
  .term {
    position: relative;
    margin-bottom: 6px;
    font-size: ${theme.font.small};
    color: ${theme.color.accordion2};
    font-weight: ${theme.fontW.medium};
  }
  .message-footer-btn-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .message-footer-btn {
      width: 66px;
      height: 30px;
      margin-left: 12px;
      color: ${theme.color.themeTxt};
      font-size: ${theme.font.small};
      font-weight: ${theme.fontW.medium};
      background: ${theme.color.accordion2};
      &.delete {
        color: ${theme.color.disableTxt};
        font-weight: ${theme.fontW.medium};
        background: ${theme.color.modalSubBg};
      }
      &.blocked {
        color: ${theme.color.disableTxt};
        font-weight: ${theme.fontW.medium};
        background: ${theme.color.modalSubBg};
        margin: 0 auto 0 0;
      }
      &.block-clear {
        width: 85px;
        color: ${theme.color.themeTxt};
        font-weight: ${theme.fontW.medium};
        background: ${theme.color.modalred};
        margin: 0 auto 0 0;
      }
    }
  }




  .footer-btn-wrap {
    display: flex;
    justify-content: space-between;
    &--btn {
      flex: 2;
      height: 28px;
      margin-top: 10px;
      &.delete {
        flex: 1;
        margin-right: 6px;
      }
    }
  }
  .bet-date {
    color: ${theme.color.gray};
    & ~ .status {
      .txt {
        margin-left: 8px;
        color: ${theme.color.gray};
        font-size: ${theme.font.small};
      }
      .read {
        display: none;
      }
      &.read {
        .read {
          display: inline-block;
        }
        .not-read {
          display: none;
        }
      }
    }
  }
`
// 답장하기, 삭제하기, 메시지 보내기 버튼 스타일
export const MessageBtnStyle = (theme: Theme) => css`
  width: 100%;
  height: 28px;
`
export const DateSpan = styled.p`
  color: ${props => props.theme.color.gray};
  & ~ .status {
    .txt {
      margin-left: 8px;
      color: ${props => props.theme.color.gray};
      font-size: ${props => props.theme.font.small};
    }
    .read {
      display: none;
    }
    &.read {
      .read {
        display: inline-block;
      }
      .not-read {
        display: none;
      }
    }
  }
`
export const MessageTitle = styled.h3`
  display: inline-block;
  width: 80%;
  margin: 0;
  font-size: ${props => props.theme.font.medium};
`
export const ListItemWrap = (theme: Theme) => css`
  line-height: 1.4rem;
  font-size: ${theme.font.small};
  &:nth-of-type(2)::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 90%;
    height: 25px;
    border-right: ${theme.border.line};
  }
`
export const DummyStyle = css`
  display: block;
  margin: 0 auto;
  width: 25px;
`

export const ItemStyle = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  line-height: 1.2rem;
  transform: translate(-50%, -70%);
  svg,
  img {
    position: relative;
    display: block;
    width: 26px;
    margin: 0 auto;
    path {
      fill: ${props => props.theme.color.themeTxt};
    }
  }
  img {
    width: 32px;
  }
  &.only-img {
    transform: translate(-50%, -50%);
  }
`
export const ReceivedStyle = css`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 56px;
`
export const SubItemName = styled.span`
  position: relative;
  font-size: ${props => props.theme.font.tiny};
  color: ${props => props.theme.color.yellow};
`
// 받기, 픽 구매 텍스트영역
export const ItemName = styled.span`
  z-index: 1;
  position: absolute;
  bottom: 2px;
  left: 50%;
  font-size: ${props => props.theme.font.small};
  transform: translate(-50%, 0);
  /* &::before {
    content: '';
    z-index: -1;
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 56px;
    height: 14px;
    background: ${props => props.theme.color.btn};
    border-radius: 0 0 6px 6px;
    transform: translate(-50%, 0);
  } */
`
export const Name = styled.span`
  display: block;
  span {
    margin-right: 5px;
    color: ${props => props.theme.color.gray};
  }
`
export const ArrowStyle = styled.span`
  position: relative;
  top: 1px;
  left: 4px;
  width: 10px;
  svg {
    transition: all 0.3s;
  }
`
// footer
export const PickButtonStyle = (theme: Theme) => css`
  width: 60px;
  height: 30px;
  padding: 0;
  line-height: 1.5rem;
  font-size: ${theme.font.medium};
  &:hover::before {
    transform: scaleX(1.1) scaleY(1.2);
  }
  &.complete,
  &.end {
    color: ${theme.color.themeTxt};
    background: ${theme.color.disableBg};
    &:hover::before {
      display: none;
    }
  }
`
export const ListItemTitle = styled.h3`
  display: inline-block;
  width: 100%;
  margin: 0 0 4px;
  font-size: ${props => props.theme.font.medium};
`
export const SellerName = styled.span`
  display: block;
  font-size: ${props => props.theme.font.small};
`
export const Txt = styled.span`
  display: block;
  color: ${props => props.theme.color.gray};
  font-size: ${props => props.theme.font.small};
`
export const Num = styled.span`
  width: 100%;
  display: inline-block;
  &.pick-popup {
    /* float: right; */
    width: 92%;
    text-align: right;
  }
`
export const Money = styled.span`
  width: 86%;
  display: inline-block;
  text-align: right;
`
export const GmoneyStyle = styled.span`
  position: relative;
  float: right;
  width: 12%;
  ${mqMin[2]} {
    width: 8%;
  }
  svg {
    position: absolute;
    right: 0;
    width: 12px;
  }
`
export const TrashStyle = styled.span`
  width: 14px;
`
//  메시지함 팝업
export const PopupBtnStyle = (theme: Theme) => css`
  position: relative;
  width: 100%;
  height: 36px;
  margin-top: 14px;
  font-size: ${theme.font.medium};
  border-radius: 50px;
  border: none;
  background-color: ${theme.color.secondaryBg};
  &.two-button {
    left: 3.5px;
    width: calc(100% - 7px);
    height: 30px;
    margin-top: 30px;
    &.cancel {
      left: -3.5px;
      border: none;
      background-color: ${theme.color.btn};
    }
  }
`
export const PopupTxt = styled.p`
  color: ${props => props.theme.color.modalTxt};
  span {
    float: none;
    width: auto;
    svg {
      position: relative;
      top: 2px;
      margin: 0 2px;
    }
  }
`
export const PickPopupRowStyle = css`
  width: auto;
  text-align: left;
  margin: 6px 20px !important;
  svg {
    top: 2px;
  }
`
// 메시지 보내기 버튼
export const MessageSendBtnStyle = (theme:Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 21px;
  right: 14px;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: ${theme.color.modalyellow};
  box-shadow: 3px 6px 12px rgba(234, 137, 2, .5);
  z-index: 2;
  svg {
    width: auto;
    height: 36px;
  }
`
export const BetSlipMessageBtnStyle = css`
  float: right;
  width: 35px;
  height: 40px;
  border-radius: 0;
  margin-right: 2px;
  svg {
    width: 15px;
    height: auto;
    transform: translate(0, 12%);
  }
`




